import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/comics';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 text-center">
          <span className="text-xs font-medium tracking-wide text-accent-600">FAQ</span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于每日更新与连载进度，你可能想问的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-transform ${
                      open ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-100 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <p className="mt-6 text-center text-sm text-foreground-600">
          还有疑问？去
          <Link to="/faq" className="mx-1 font-medium text-primary-600 hover:text-primary-700">常见问题</Link>
          查看更多，或随时联系我们。
        </p>
      </div>
    </section>
  );
}